import {BaseDao} from "./BaseDao";
import {ApiHelper} from "../apiHelper";
import {ConstantMan} from "../constantMan";
import {Observable} from "rxjs";
import {MasterChannel} from "../../models/masterChannel";
import {HttpHeaders} from "@angular/common/http";

export class MasterChannelDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.MASTERCHANNELS, apiHelper);
    }

    sync(): Observable<any> {
        let url = this.apiHelper.getServiceName() + this.getResource() + '/sync';
        let headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'GET', null, null, headers);
    }

    findByMonitoredChannelId(id: string): Observable<MasterChannel[]> {
        let url = this.apiHelper.getServiceName() + this.getResource() + `/monitored/${id}`;
        let headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'GET', null, null, headers);
    }

    getNationalChannels() {
      let url = this.apiHelper.getServiceName() + this.getResource() + `/national`;
      let headers = this.apiHelper.getDefaultHeader();
      return this.apiHelper.apiCall(url, 'GET', null, null, headers);
    }

    getMasterChannelsWithCcr(publicId?: string): Observable<MasterChannel[]> {
        let url = this.apiHelper.getServiceName() + this.getResource() + '/ccr';
        let headers: HttpHeaders;
        if (publicId) {
            headers = this.apiHelper.getChangeManagementPublicHeaders(publicId)
        } else {
            headers = this.apiHelper.getDefaultHeader();
        }
        return this.apiHelper.apiCall(url, 'GET', null, null, headers);
    }
}
